import { AGUAppModuleDefinition, AGUNavTone } from './app-module-definition';

/**
 * A module's tool colour in every nav that lists it — the sidebar rail, the phone bottom tabs and the phone drawer: its `NavTone`,
 * else its module `Accent` (P/Member_Hub.html:1887-1925). One rule, so the three navs can never disagree on a module's colour.
 */
export function ToneOf(module: Pick<AGUAppModuleDefinition, 'NavTone' | 'Accent'>): AGUNavTone {
    return module.NavTone ?? module.Accent;
}
